"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UNAVAILABLE_ICONS_DICTIONARY = exports.UNAVAILABLE_ICONS = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./UnavailableIcon.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var UNAVAILABLE_ICON_TYPES = {
  4: 'admin',
  1: 'food',
  11: 'time',
  10: 'water',
  16: 'elevator',
  7: 'lunch',
  13: 'medic',
  6: 'meeting',
  15: 'money',
  14: 'notify',
  3: 'people',
  12: 'unknown',
  2: 'restroom',
  5: 'talking',
  8: 'station',
  9: 'coffee'
};
var UNAVAILABLE_ICONS = new Proxy(UNAVAILABLE_ICON_TYPES, {
  get: function get(object, property) {
    return object.hasOwnProperty(property) ? object[property] : 'unknown';
  }
});
exports.UNAVAILABLE_ICONS = UNAVAILABLE_ICONS;
var UNAVAILABLE_ICONS_DICT = {
  4: 'admin-v2',
  1: 'apple',
  11: 'clock',
  10: 'droplet',
  16: 'elevator',
  7: 'lunch',
  13: 'medic',
  6: 'meeting-v2',
  15: 'money',
  14: 'notify',
  3: 'people',
  12: 'question-neg',
  2: 'restroom',
  5: 'speech',
  8: 'station-cog',
  9: 'teacup'
};
var UNAVAILABLE_ICONS_DICTIONARY = new Proxy(UNAVAILABLE_ICONS_DICT, {
  get: function get(object, property) {
    return object.hasOwnProperty(property) ? object[property] : 'question-neg';
  }
});
exports.UNAVAILABLE_ICONS_DICTIONARY = UNAVAILABLE_ICONS_DICTIONARY;

var UnavailableIcon = function UnavailableIcon(_ref) {
  var type = _ref.type,
      size = _ref.size,
      selected = _ref.selected,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-unavailable-icon ".concat(size, " ").concat(onClick != null ? 'selectable' : '', " ").concat(selected ? 'selected' : ''),
    "data-unavailable-status": UNAVAILABLE_ICONS[type],
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + UNAVAILABLE_ICONS_DICTIONARY[type]
  }));
};

UnavailableIcon.propTypes = {
  type: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  size: _propTypes["default"].oneOf(['sm', 'md', 'lg']),
  selected: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
UnavailableIcon.defaultProps = {
  type: 12,
  size: 'lg'
};
var _default = UnavailableIcon;
exports["default"] = _default;